import React, { useEffect, useState } from "react";
import "./profilepage.css";
import BackButton from "../../generic/elements/backbutton/BackButton";
import { Spin } from "antd";
import { useReadMemory } from "../../generic/hooks/useReadMemory";
import MemoryType from "../../../service/memory/enum/MemoryType";
import { executeIntent } from "../../utils/IntentExecutor";
import IntentType from "../../../intentexecutor/utils/IntentType";
import { mapCareCoordinatorToProfileData } from "../../../components/generic/profiledataextractor/profileDataExtractor";
import { useRecoilValue } from "recoil";
import { currentConfiguration } from "../../../service/memory/recoil/configurationstore";
import ConfigurationConstants from "../../utils/configurationconstants";
import { useObservable } from "../../generic/hooks/useObservable";
import { workforceDataUpdateResponse } from "../../carecoordinator/workforce/AddEditWorkforceModal";
import AddEditWorkforceModal from "../../carecoordinator/workforce/AddEditWorkforceModal";
import CarePlan from "../../carecoordinator/careplan/CarePlan";
import { getMediaKeyObjectStore } from "../../../components/generic/formbuilder/networkservice/FormService";
import SectionCard from "../../generic/sectioncard/SectionCard";
import { officeLabel } from "../../../components/recoil/officeLabelRecoil";
import ProfileOverview from "../../../components/generic/profileoverview/ProfileOverview";
import { useSearchParams } from "react-router-dom";

const CoordinatorProfilePage = () => {
	const localUser = useReadMemory(MemoryType.USER);
	const [userDetails, setUserDetails] = useState(undefined);
	const [searchParams] = useSearchParams();
	const identifier = searchParams.get("identifier") || localUser?.userIdentifier;
	const [isLoading, setIsloading] = useState(false);
	const [userProfileData, setUserProfileData] = useState({});
	const [openEditVolunteerModal, setOpenEditVolunteerModal] = useState(false);
	const label = useRecoilValue(officeLabel);
	const configuration = useRecoilValue(currentConfiguration);
	const [allowProfileEdit, setAllowProfileEdit] = useState(false);
	const [reload, setReload] = useState(false);
	const bucketName = configuration[ConfigurationConstants.NIRAMAYA_FORMS_BUCKETNAME];
	useObservable(workforceDataUpdateResponse, setReload);

	useEffect(() => {
		const configurationAllowProfileEdit = configuration[ConfigurationConstants.FEATUREACCESS_COORDINATOR_PROFILE_EDIT];
		setAllowProfileEdit(configurationAllowProfileEdit?.visibility)
	}, [configuration]);

	useEffect(() => {
		const actions = [
			(allowProfileEdit) && {
				label: 'Edit',
				icon: 'ICON_FOR_PROFILE_EDIT',
				map: 'ICON_FOR_PROFILE_EDIT',
				functionName: () => {
					setOpenEditVolunteerModal(true);
				}
			},].filter(Boolean);
		const profile = mapCareCoordinatorToProfileData(userDetails, label);
		const coordinatorProfile = {
			...profile, actionIcons: actions, actionData: userDetails
		}

		setUserProfileData(coordinatorProfile);
	}, [allowProfileEdit, userDetails, label])

	useEffect(() => {
		const getUserDetails = async () => {
			setIsloading(true);
			const payload = {
				userIdentifier: identifier,
			};
			const userDataJson = await executeIntent(
				IntentType.GET_WORKFORCE_DETAILS_BY_USER_IDENTIFIER,
				payload
			);
			if (userDataJson[0]?.profilePicture) {
				const icon = await getMediaKeyObjectStore(userDataJson[0]?.profilePicture, bucketName?.value);
				if (icon) {
					setUserDetails({ ...userDataJson[0], icon });
				} else {
					setUserDetails(userDataJson[0]);
				}
			} else {
				setUserDetails(userDataJson[0]);
			}
			setIsloading(false);
		};
		getUserDetails();
	}, [bucketName?.value, identifier, localUser.userIdentifier, reload]);

	return (
		<section className="section-content">
			<div className="form-renderer-back-button">
				<BackButton />
				<p>Care Coordinator Profile Page</p>
			</div>
			<div className="patient-profile-overview-shell">
				{(userDetails !== undefined && !isLoading) ? (
					userProfileData?.overviewConfig ? (
						<>
							<ProfileOverview
								overviewConfig={userProfileData.overviewConfig}
								actionIcons={userProfileData.actionIcons}
								actionData={userProfileData.actionData}
							/>
							{openEditVolunteerModal && (
								<AddEditWorkforceModal
									openAddWorkforceModal={openEditVolunteerModal}
									setOpenAddWorkforceModal={setOpenEditVolunteerModal}
									editVolunteer={true}
									userIdentifier={userDetails?.userIdentifier}
									showAdditionalFields={true}
									disableEmail={true}
								/>
							)}
						</>
					) : (
						<Spin className="d-flex justify-content-center m-auto py-5" />
					)
				) : (
					<Spin className="d-flex justify-content-center m-auto py-5" />
				)}
			</div>

			<SectionCard title="Volunteer Request" className="listCardStylingThirdRow">
				<CarePlan coordinatorIdentifier={identifier} carePlanClass="px-3" spinnerClass="spinnerCenter" />
			</SectionCard>
		</section>
	);
};

export default CoordinatorProfilePage;
